var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#icon-btn_previous';
                    var viewUrl = 'sprites.svg#view-icon-btn_previous';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };